(function () {
  var PLAN_NAME = 'The Triology Challenge';
  var NEW_PRICE_HTML = '(AED&nbsp;99.00)';
  var NEW_DISPLAY_PRICE_HTML = 'AED&nbsp;99.00';
  var ORIGINAL_DISPLAY_PRICE_TEXT = 'AED 157.50';
  var SELECTOR = 'select.recurpay__frequency_select.recurpay__frequency';

  function normalizeText(str) {
    return (str || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function updateOption(option) {
    if (!option) return false;

    var priceSpan = option.querySelector('.recurpay-dropdown-price');
    if (priceSpan) {
      if (priceSpan.innerHTML !== NEW_PRICE_HTML) {
        priceSpan.innerHTML = NEW_PRICE_HTML;
      }
    } else {
      option.innerHTML =
        '<span class="recurpay-dropdown-option">' +
        PLAN_NAME +
        '</span>&nbsp;<span class="recurpay-dropdown-price">' +
        NEW_PRICE_HTML +
        '</span>';
    }

    return true;
  }

  function updateOriginalOptions(select) {
    if (!select || !select.dataset.originalOptions) return;

    try {
      var decoded = decodeURIComponent(select.dataset.originalOptions);

      decoded = decoded.replace(
        /(<option\b[^>]*data-plan-name="The%20Triology%20Challenge"[\s\S]*?<span class="recurpay-dropdown-price">).*?(<\/span>[\s\S]*?<\/option>)/,
        '$1' + NEW_PRICE_HTML + '$2'
      );

      decoded = decoded.replace(
        /(<option\b[^>]*data-plan-name="The Triology Challenge"[\s\S]*?<span class="recurpay-dropdown-price">).*?(<\/span>[\s\S]*?<\/option>)/,
        '$1' + NEW_PRICE_HTML + '$2'
      );

      select.dataset.originalOptions = encodeURIComponent(decoded);
    } catch (e) {
      console.warn('Could not update recurpay data-original-options', e);
    }
  }

  function getSelectedPlan(select) {
    if (!select) return '';

    var selectedOption = select.options && select.selectedIndex >= 0
      ? select.options[select.selectedIndex]
      : null;

    if (!selectedOption) return '';

    return (
      selectedOption.getAttribute('data-plan-name') ||
      selectedOption.dataset.planName ||
      normalizeText(selectedOption.textContent)
    );
  }

  function updateDisplayedPrice(select) {
    var selectedPlan = getSelectedPlan(select);
    var isTargetPlan = normalizeText(selectedPlan) === normalizeText(PLAN_NAME);

    document.querySelectorAll('.recurpay__group_selling_price.recurpay__group_discounted_price .money.buckscc-money').forEach(function (el) {
      if (isTargetPlan) {
        el.innerHTML = NEW_DISPLAY_PRICE_HTML;
        el.setAttribute('bucks-original', 'AED&nbsp;99.00');
        el.setAttribute('bucks-init', '99.00');
      } else {
        var currentText = normalizeText(el.textContent);
        if (currentText === normalizeText('AED 99.00')) {
          el.innerHTML = 'AED&nbsp;157.50';
          el.setAttribute('bucks-original', 'AED&nbsp;157.50');
          el.setAttribute('bucks-init', '157.50');
        }
      }
    });
  }

  function applyChange(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(SELECTOR).forEach(function (select) {
      var option = select.querySelector('option[data-plan-name="' + PLAN_NAME + '"]');
      if (option) {
        updateOption(option);
        updateOriginalOptions(select);
        updateDisplayedPrice(select);

        if (!select.dataset.triologyPriceBound) {
          select.addEventListener('change', function () {
            updateDisplayedPrice(select);
          });
          select.dataset.triologyPriceBound = 'true';
        }
      }
    });
  }

  function initObserver() {
    var scheduled = false;

    function queueApply() {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(function () {
        scheduled = false;
        applyChange(document);
      });
    }

    applyChange(document);
    setTimeout(queueApply, 300);
    setTimeout(queueApply, 800);
    setTimeout(queueApply, 1500);
    setTimeout(queueApply, 2500);

    var observer = new MutationObserver(function () {
      queueApply();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-original-options', 'class', 'selected', 'value']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }
})();

(function () {
  function isMobileMenu() {
    return window.matchMedia('(max-width: 999px)').matches;
  }

  document.addEventListener('click', function (event) {
    if (!isMobileMenu()) return;

    var summary = event.target.closest('[data-mobile-submenu-summary]');
    if (!summary || event.target.closest('.header-sidebar__accordion-toggle')) return;

    var link = summary.querySelector('[data-mobile-submenu-link]');
    if (!link || !link.href) return;

    event.preventDefault();
    window.location.href = link.href;
  });
})();